export default __webpack_public_path__ + "images/34c4457b5ab0f46d7fe98254ffbb15a1-pyxirhead.svg";